(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muhursah-campaign-bar"] && !Shopify.designMode) return;
  try {
    
  class MhCampaignCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Number(this.dataset.end) * 1000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.boxes = {};
      this.querySelectorAll('[data-unit]').forEach((box) => {
        this.boxes[box.dataset.unit] = box;
      });
      this.started = false;
      this.tick();
      this.started = true;
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    set(unit, value) {
      const digit = this.boxes[unit];
      if (!digit || digit.textContent === value) return;
      digit.textContent = value;
      if (this.started && !this.reduceMotion.matches && digit.animate) {
        digit.animate(
          [
            { transform: 'translateY(-60%)', opacity: 0 },
            { transform: 'translateY(0)', opacity: 1 },
          ],
          { duration: 280, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)' }
        );
      }
    }

    tick() {
      const left = Math.floor((this.end - Date.now()) / 1000);
      if (!Number.isFinite(left) || left <= 0) {
        this.hidden = true;
        return;
      }
      const pad = (value) => String(value).padStart(2, '0');
      this.classList.toggle('is-urgent', left < 86400);
      this.set('days', String(Math.floor(left / 86400)));
      this.set('hours', pad(Math.floor((left % 86400) / 3600)));
      this.set('minutes', pad(Math.floor((left % 3600) / 60)));
      this.set('seconds', pad(left % 60));
      this.timer = setTimeout(() => this.tick(), 1000 - (Date.now() % 1000) + 20);
    }
  }

  if (!customElements.get('mh-campaign-countdown')) {
    customElements.define('mh-campaign-countdown', MhCampaignCountdown);
  }

  if (!window.mhCampaignSweepReady && 'IntersectionObserver' in window) {
    window.mhCampaignSweepReady = true;
    const mhSweepObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('is-offscreen', !entry.isIntersecting));
    });
    const mhObserveBars = () => document.querySelectorAll('.campaign-bar').forEach((bar) => mhSweepObserver.observe(bar));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mhObserveBars, { once: true });
    } else {
      mhObserveBars();
    }
  }

  if (!window.mhCampaignCopyReady) {
    window.mhCampaignCopyReady = true;

    const mhCopyFallback = (text) => {
      const field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (error) {
        ok = false;
      }
      field.remove();
      return ok;
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.campaign-bar__code');
      if (!button) return;
      const bar = button.closest('.campaign-bar');
      const status = bar ? bar.querySelector('.campaign-bar__status') : null;
      const text = button.dataset.copy || '';
      const done = () => {
        button.classList.add('is-copied');
        if (status && bar) status.textContent = bar.dataset.copiedMessage || '';
        clearTimeout(button.mhCopyTimer);
        button.mhCopyTimer = setTimeout(() => {
          button.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 1600);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done, () => {
          if (mhCopyFallback(text)) done();
        });
      } else if (mhCopyFallback(text)) {
        done();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
